import { IdCard } from "lucide-react";
import type { AppInfo } from "@/shared/apps";

// Where the app sits in the shell: its tabs, "+ New" entries, settings and first steps.
export const app: AppInfo = {
  key: "hr",
  icon: IdCard,
  tabs: [
    { to: "/hr/employees", label: "nav.employees", perm: ["hr.employee.read"] },
    { to: "/hr/org-chart", label: "nav.orgChart", perm: ["hr.employee.read"] },
    { to: "/hr/announcements", label: "nav.announcements", perm: ["hr.announcement.read"] },
    { to: "/hr/attendance", label: "nav.attendance", perm: ["hr.attendance.read"] },
    { to: "/hr/leaves", label: "nav.leave", perm: ["hr.leave.read"] },
    { to: "/hr/checklists", label: "nav.checklists", perm: ["hr.employee.update"] },
    { to: "/hr/violations", label: "nav.violations", perm: ["hr.violation.read"] },
    { to: "/hr/insurance", label: "nav.insurance", perm: ["hr.insurance.read"] },
    { to: "/hr/custody", label: "nav.custody", perm: ["hr.custody.read"] },
    { to: "/hr/recruitment", label: "nav.recruitment", perm: ["hr.recruitment.read"] },
    { to: "/hr/reviews", label: "nav.reviews", perm: ["hr.review.read"] },
    { to: "/hr/training", label: "nav.training", perm: ["hr.training.read"] },
    { to: "/hr/performance", label: "nav.performance", perm: ["hr.report.read"] },
    { to: "/hr/reports", label: "nav.hrReports", perm: ["hr.report.read"] },
  ],
  create: [{ label: "create.employee", to: "/hr/employees?new=1", perm: "hr.employee.create" }],
  settings: { to: "/settings/hr", perm: ["hr.settings.read"] },
  setup: { first_employee: "/hr/employees?new=1", invite_employees: "/hr/employees?invite=1" },
};
